import { lazyRouteComponent } from "@tanstack/react-router";

import type { PageDef } from "@/app/registry";

/** Set or reset a password from an emailed link; works signed out (like /signup). */
export const pages: PageDef[] = [];

export const publicPages: PageDef[] = [
  {
    path: "/set-password",
    title: "Set password",
    component: lazyRouteComponent(() => import("./SetPasswordPage"), "SetPasswordPage"),
    validateSearch: (s) => ({
      ...(typeof s.uid === "string" || typeof s.uid === "number" ? { uid: String(s.uid) } : {}),
      ...(typeof s.token === "string" ? { token: s.token } : {}),
    }),
  },
  {
    // the confirmation email's link, or the fallback code (V034)
    path: "/verify-email",
    title: "Confirm your email",
    component: lazyRouteComponent(() => import("./VerifyEmailPage"), "VerifyEmailPage"),
    validateSearch: (s) => ({
      ...(typeof s.uid === "string" || typeof s.uid === "number" ? { uid: String(s.uid) } : {}),
      ...(typeof s.token === "string" ? { token: s.token } : {}),
      ...(typeof s.email === "string" ? { email: s.email } : {}),
    }),
  },
];
